import React from 'react';
import Button from '../../Button';
import get from 'lodash/get';

export default function GetAcceptableChildren(children) {
    return React.Children.toArray(children).filter(child => get(child, 'type', '') === Button);
}
